import { useEffect, useState } from 'react';
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { stringifyEntityRef } from '@backstage/catalog-model';
import { createFormField } from '@backstage/plugin-scaffolder-react/alpha';

export function SystemPickerComponent(props: {
  formData?: string;
  onChange(value: string): void;
  schema?: { title?: string };
  rawErrors?: string[];
  idSchema?: { $id: string };
}) {
  const catalog = useApi(catalogApiRef);
  const [options, setOptions] = useState<string[]>([]);
  const [error, setError] = useState<string>();
  useEffect(() => {
    let active = true;
    catalog.getEntities({ filter: { kind: 'System' } }).then(
      result => {
        if (active) setOptions(result.items.map(stringifyEntityRef).sort());
      },
      () => {
        if (active)
          setError(
            'Could not load existing systems. Retry before creating a project.',
          );
      },
    );
    return () => {
      active = false;
    };
  }, [catalog]);
  return (
    <Autocomplete
      freeSolo
      options={options}
      value={props.formData || ''}
      inputValue={props.formData || ''}
      onInputChange={(_, value) => props.onChange(value)}
      onChange={(_, value) => props.onChange(value || '')}
      renderInput={params => (
        <TextField
          {...params}
          id={props.idSchema?.$id}
          label={props.schema?.title || 'System'}
          fullWidth
          variant="outlined"
          margin="normal"
          error={!!error || !!props.rawErrors?.length}
          helperText={
            error ||
            props.rawErrors?.join(', ') ||
            'Select an existing System or enter a new name. New systems use namespace abcdigital and the project’s responsible team.'
          }
        />
      )}
    />
  );
}

export const SystemPicker = createFormField({
  name: 'SystemPicker',
  component: SystemPickerComponent as any,
});
